import { dateFormats } from 'constants/common'

export const isNextOpeningSlotToday = (
  nextSlot: ProviderSlot,
  format: (
    date: Date | string | number,
    dateFormat: string,
    formatTimeZone?: string
  ) => string
): boolean => {
  const formattedSlot = format(nextSlot?.start, dateFormats.MONTH_DATE_FORMAT)
  const formattedTodaysDate = format(new Date(), dateFormats.MONTH_DATE_FORMAT)
  return formattedSlot === formattedTodaysDate
}
